/**
* Constants used in XRP Ledger.
*/

export const NATIVE_CURRENCY = 'XRP';
Object.freeze(NATIVE_CURRENCY);

export const DROPS_PER_XRP = 1000000.0;
Object.freeze(DROPS_PER_XRP);

export const LPTOKEN_PREFIX = 'LP'
Object.freeze(LPTOKEN_PREFIX);

export const ACCOUNTDELETE_ENABLE_LEDGER = 55313921;
Object.freeze(ACCOUNTDELETE_ENABLE_LEDGER);

/**
* Enum of all Transaction Types supported by XRPL
*
*/

const TransactionType = {
  AccountSet: 'AccountSet',
  AccountDelete: 'AccountDelete',
  AMMBid: 'AMMBid',
  AMMClawback: 'AMMClawback',
  AMMCreate: 'AMMCreate',
  AMMDelete: 'AMMDelete',
  AMMDeposit: 'AMMDeposit',
  AMMVote: 'AMMVote',
  AMMWithdraw: 'AMMWithdraw',
  Batch: 'Batch',
  CredentialAccept: 'CredentialAccept',
  CredentialCreate: 'CredentialCreate',
  CredentialDelete: 'CredentialDelete',
  CheckCancel: 'CheckCancel',
  CheckCash: 'CheckCash',
  CheckCreate: 'CheckCreate',
  Clawback: 'Clawback',
  DepositPreauth: 'DepositPreauth',
  DelegateSet: 'DelegateSet',
  DIDDelete: 'DIDDelete',
  DIDSet: 'DIDSet',
  EscrowCancel: 'EscrowCancel',
  EscrowCreate: 'EscrowCreate',
  EscrowFinish: 'EscrowFinish',
  LedgerStateFix: 'LedgerStateFix',
  LoanBrokerCoverClawback: 'LoanBrokerCoverClawback',
  LoanBrokerCoverDeposit: 'LoanBrokerCoverDeposit',
  LoanBrokerCoverWithdraw: 'LoanBrokerCoverWithdraw',
  LoanBrokerDelete: 'LoanBrokerDelete',
  LoanBrokerSet: 'LoanBrokerSet',
  LoanDelete: 'LoanDelete',
  LoanManage: 'LoanManage',
  LoanPay: 'LoanPay',
  LoanSet: 'LoanSet',
  MPTokenAuthorize: 'MPTokenAuthorize',
  MPTokenIssuanceCreate: 'MPTokenIssuanceCreate',
  MPTokenIssuanceDestroy: 'MPTokenIssuanceDestroy',
  MPTokenIssuanceSet: 'MPTokenIssuanceSet',
  NFTokenAcceptOffer: 'NFTokenAcceptOffer',
  NFTokenBurn: 'NFTokenBurn',
  NFTokenCancelOffer: 'NFTokenCancelOffer',
  NFTokenCreateOffer: 'NFTokenCreateOffer',
  NFTokenMint: 'NFTokenMint',
  NFTokenModify: 'NFTokenModify',
  OfferCancel: 'OfferCancel',
  OfferCreate: 'OfferCreate',
  OracleDelete: 'OracleDelete',
  OracleSet: 'OracleSet',
  Payment: 'Payment',
  PaymentChannelClaim: 'PaymentChannelClaim',
  PaymentChannelCreate: 'PaymentChannelCreate',
  PaymentChannelFund: 'PaymentChannelFund',
  PermissionedDomainDelete: 'PermissionedDomainDelete',
  PermissionedDomainSet: 'PermissionedDomainSet',
  SetRegularKey: 'SetRegularKey',
  SignerListSet: 'SignerListSet',
  TicketCreate: 'TicketCreate',
  TrustSet: 'TrustSet',
  VaultClawback: 'VaultClawback',
  VaultCreate: 'VaultCreate',
  VaultDelete: 'VaultDelete',
  VaultDeposit: 'VaultDeposit',
  VaultSet: 'VaultSet',
  VaultWithdraw: 'VaultWithdraw',
  EnableAmendment: 'EnableAmendment',
  SetFee: 'SetFee',
  UNLModify: 'UNLModify',
};
Object.freeze(TransactionType);
export { TransactionType };

export const NFTokenMintFlags = {
  tfBurnable: 'tfBurnable',
  tfOnlyXRP: 'tfOnlyXRP',
  tfTrustLine: 'tfTrustLine',
  tfTransferable: 'tfTransferable',
  tfMutable: 'tfMutable',
}

// Enum of supported Advisory types
const AdvisoryType = {
  SPAM: 'SPAM',
  HACK: 'HACK',
  LEA: 'LEA',
  SCAM: 'SCAM',
}
Object.freeze(AdvisoryType)
export { AdvisoryType }

export const AdvisoryTypes = [
  AdvisoryType.SPAM,
  AdvisoryType.HACK,
  AdvisoryType.LEA,
]
Object.freeze(AdvisoryTypes)

export const XrplNetwork = {
  XrplMainnet: 0,
  XrplTestnet: 1,
  XrplDevnet: 2,
  XrplBatchTestnet: 21336,
  XahauMainnet: 21337,
  XahauTestnet: 21338,
}
Object.freeze(XrplNetwork)

export const XrplNetworkName = {
  XrplMainnet: "mainnet",
  XrplTestnet: "testnet",
  XrplDevnet: "devnet",
  XrplBatchTestnet: "batch-testnet",
  XahauMainnet: "xahau-mainnet",
  XahauTestnet: "xahau-testnet",
}
Object.freeze(XrplNetworkName)

export const XrplNetworkUrls = {
  XrplMainnet: "https://xrpscan.com",
  XrplTestnet: "https://testnet.xrpscan.com",
  XrplDevnet: "https://devnet.xrpscan.com",
  XrplBatchTestnet: "https://batch-testnet.xrpscan.com",
  XahauMainnet: "https://xahscan.com",
  XahauTestnet: "https://testnet.xahscan.com",
}
Object.freeze(XrplNetworkUrls)

/*
* Returns Network name for a given Network ID
*/
export const getXrplNetworkName = (NetworkID) => {
  const networkMap = {
    [XrplNetwork.XrplMainnet]: XrplNetworkName.XrplMainnet,
    [XrplNetwork.XrplTestnet]: XrplNetworkName.XrplTestnet,
    [XrplNetwork.XrplDevnet]: XrplNetworkName.XrplDevnet,
    [XrplNetwork.XrplBatchTestnet]: XrplNetworkName.XrplBatchTestnet,
    [XrplNetwork.XahauMainnet]: XrplNetworkName.XahauMainnet,
    [XrplNetwork.XahauTestnet]: XrplNetworkName.XahauTestnet,
  };
  return networkMap[NetworkID] ?? XrplNetworkName.XrplMainnet;
}

export const Burn2MintTransactionTypes = [
  TransactionType.AccountSet,
  TransactionType.SetRegularKey,
  TransactionType.SignerListSet,
]
Object.freeze(Burn2MintTransactionTypes)

export const AccountSettingDescription = {
  defaultRipple: "This account allows rippling on its trust lines by default",
  depositAuth: "This account is using Deposit Authorization and does not accept any payments from unknown parties",
  disableMasterKey: "This account's master key pair is disabled",
  disallowIncomingCheck: "This account does not allow others to send Checks to it",
  disallowIncomingNFTokenOffer: "This account does not allow others to make NFT buy or sell offers to it",
  disallowIncomingPayChan: "This account does not allow others to make Payment Channels to it",
  disallowIncomingTrustline: "This account does not allow others to make trust lines to it",
  disallowIncomingXRP: "This account does not want to receive XRP from others. (This is advisory, and not enforced at a protocol level.)",
  globalFreeze: "All tokens issued by this account are currently frozen",
  noFreeze: "This account has permanently given up the abilities to freeze individual trust lines or end a global freeze",
  passwordSpent: "This account has used its free SetRegularKey transaction",
  requireAuthorization: "This account is using Authorized Trust Lines to limit who can hold the tokens it issues",
  requireDestinationTag: "This account requires a destination tag on all payments it receives",
}
Object.freeze(AccountSettingDescription)

/*
* This constant is used to control how large Amounts are shown in the UI. Amount
* larger than this threshold would be shown in the following forat:
* [LEADING_DIGITS] ... [COUNT_OF_ZEROS_MINUS_3] ... 000
*/
export const AMOUNT_LARGE_VALUE_THRESHOLD = 1 * 1000 * 1000 * 1000 * 1000;

/*
* Browser Cookie ID to store GeoIP country code.
* This value is used to show/hide advertising campaigns
*/
export const CAMPAIGN_LOCATION_KEY = "campaign.location";
